import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { Button } from '../../common/button'
import { OfferPlan } from '../../common'

import { getIsLegalFlow, getUserId } from '../../../redux/slices/userSlice'
import { ampEvent } from '../../../utils/amplitude'
import { paramsToQuery } from '../../../utils/historyDecorators'

import './styles.scss'

const Offer = ({
	selectedOffer,
	offers,
	handleSelectOffer,
	setIsActiveModal,
}) => {
	const user_id = useSelector(getUserId)
	const isLegalFlow = useSelector(getIsLegalFlow)

	const handleBuySubscription = () => {
		setIsActiveModal(true)
		ampEvent('Checkout_shown')
		document.body.style.overflow = 'hidden'
	}

	return (
		<div className="discount-offer">
			{!isLegalFlow ? (
				<>
					<div className="discount-offer__logo">
						<img
							className="discount-offer__logo-img"
							src="refine192.png"
							alt="disc-logo"
						/>
						<span>Refine</span>
					</div>
					<h2 className="discount-offer__title">
						Make it Anyway. Make it with Refine!
					</h2>
					<Button
						className="discount-offer__btn"
						buttonText="Get my Discount"
						onClick={handleBuySubscription}
					/>
				</>
			) : (
				<div className="discount-offer__list">
					{offers.map(offer => (
						<OfferPlan
							key={offer.id}
							onOfferClicked={() => handleSelectOffer(offer.id)}
							isDiscount={true}
							{...offer}
						/>
					))}
					<Button
						className="discount-offer__offers-button"
						buttonText="Get my Discount"
						onClick={handleBuySubscription}
					/>
					<p className="discount-offer__price-info">
						By continuing you agree that if you don&apos;t cancel at least 24
						hours prior to the end of the{' '}
						<span className="discount-offer__price-info__accent">
							3-days trial for $0.99
						</span>
						, you will automatically be charged{' '}
						<span className="discount-offer__price-info__accent">
							${selectedOffer.pricePerPeriod}{' '}
							{selectedOffer.periodTime === 3 ? 'per 3' : 'every'}{' '}
							{selectedOffer.period}
						</span>{' '}
						until you cancel in settings. Learn more about cancellation and
						refund policy in{' '}
						<Link
							className="discount-offer__price-info__link"
							to={{
								pathname: '/subscription-terms',
								search: paramsToQuery({ user_id }),
							}}
						>
							Subscription Terms
						</Link>
						.
					</p>
				</div>
			)}
		</div>
	)
}

export { Offer }
